var map = {
	"./ic-arrow_next.svg": "b848",
	"./ic-check.svg": "be61",
	"./ic-checkin.svg": "c9f9",
	"./ic-eatmap.svg": "1053",
	"./ic-hamburger.svg": "e2dd",
	"./ic-lock.svg": "a082",
	"./ic-nav_close.svg": "a385",
	"./ic-news.svg": "5dd9",
	"./ic-reflesh.svg": "060d",
	"./ic-share.svg": "9e1d",
	"./ic-twitter.svg": "e9ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17a1";